import { Result } from 'antd';

const errorMessage = (
  <div>
    This may be due to a recent update. Please try the following:
    <ul className='list-disc text-left'>
      <li>Press Ctrl + Shift + R (or Cmd + Shift + R on Mac) to reload the page without using cached files.</li>
      <li>If the issue persists, try clearing your browser cache and reloading the page.</li>
    </ul>
    We apologize for the inconvenience and appreciate your patience.
  </div>
)

const ClearCachePage = () => {
  return (
    <div className='flex items-center justify-center h-full'>
      <Result
        status="500"
        title="The page you are trying to access failed to load."
        subTitle={<span className='text-lg'>{errorMessage}</span>}
      />
    </div>
  );
}

export default ClearCachePage;